import { search } from '../Utils/SearchUtils'
import * as actionTypes from './actionTypes' 

const initialState = {
    term: '',
    results: [],
    modal:
    {
        title: "",
        subtitle: "",
        image: "",
    }
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SEARCH:
            return action_search(state, action.term);
        case actionTypes.SHOW_MODAL:
            return show_modal(state, action.modal);
        default:
            return { ...state }
    }
}

const show_modal = (state, modal) => {
    return { ...state, modal: modal }
}

const action_search = (state, term) => {
    if (term.length >= 3) {
        return {
            ...state,
            results: search(term),
            term: term
        }
    } else {
        return {
            ...state,
            results: [],
            term: ''
        }
    }
}

export default reducer